module.exports = __webpack_public_path__ + "static/media/Nunito-Regular.04ba025b.ttf";